"use strict";

exports.__esModule = !0, exports.default = void 0;
var _styledBase = _interopRequireDefault(require("@emotion/styled-base")),
  _react = _interopRequireDefault(require("react")),
  _Option = _interopRequireDefault(require("./Option")),
  _Input = _interopRequireDefault(require("./Input")),
  _constants = require("../constants"),
  _util = require("../util");
function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Content = function (a) {
    var b = a.props,
      c = a.state,
      d = a.methods;
    return _react.default.createElement(ContentComponent, {
      className: _constants.LIB_NAME + "-content " + (b.multi ? _constants.LIB_NAME + "-type-multi" : _constants.LIB_NAME + "-type-single"),
      onClick: function onClick(a) {
        a.stopPropagation(), d.dropDown("open");
      }
    }, b.contentRenderer ? b.contentRenderer({
      props: b,
      state: c,
      methods: d
    }) : _react.default.createElement(_react.default.Fragment, null, b.multi ? c.values && c.values.map(function (a) {
      return _react.default.createElement(_Option.default, {
        key: "" + (0, _util.getByPath)(a, b.valueField) + (0, _util.getByPath)(a, b.labelField),
        item: a,
        state: c,
        props: b,
        methods: d
      });
    }) : c.values && 0 < c.values.length && _react.default.createElement("span", null, (0, _util.getByPath)(c.values[0], b.labelField)), _react.default.createElement(_Input.default, {
      props: b,
      methods: d,
      state: c
    })));
  },
  ContentComponent = (0, _styledBase.default)("div", {
    target: "e1gn6jc30",
    label: "ContentComponent"
  })("production" === process.env.NODE_ENV ? {
    name: "1vw3e5y",
    styles: "display:flex;flex:1;flex-wrap:wrap;"
  } : {
    name: "1vw3e5y",
    styles: "display:flex;flex:1;flex-wrap:wrap;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }),
  _default = Content;
exports.default = _default;